import { Modal, RemoveScroll } from '@mantine/core';
import clsx from 'clsx';

import styles from './fullscreenWidgetModal.module.scss';

export type FullscreenWidgetModalProps = {
  children?: React.ReactNode;
  onClose: () => void;
  opened: boolean;
};

export function FullscreenWidgetModal({
  children,
  opened,
  onClose,
}: FullscreenWidgetModalProps) {
  return (
    <Modal.Root
      centered
      onClose={onClose}
      opened={opened}
      xOffset={0}
      size="auto"
      classNames={{
        inner: clsx(RemoveScroll.classNames.zeroRight, styles['modal__inner']),
      }}
    >
      <Modal.Overlay blur="5" className={styles['overlay__root']} />
      <Modal.Content
        className={`${styles['container__root']} portal-fullscreen-modal-content`}
      >
        <div className={styles['content__root']}>{children}</div>
      </Modal.Content>
    </Modal.Root>
  );
}
